module.exports = __webpack_public_path__ + "static/img/index_main_footer.bf69198.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/index_main_footer.png
// module id = SrSG
// module chunks = 1